import { CIsActive, CAppusers, CDataRequest } from "./system-interface";
import { Injectable, OnInit } from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/take";
import "rxjs/add/observable/of";
import { Observable, EMPTY, throwError, BehaviorSubject } from "rxjs";
import { catchError } from "rxjs/operators";
import "rxjs/add/operator/catch";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";

const httpOptions = {
  headers: new HttpHeaders({
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type, X-Requested-With",
  }),
};
declare var saveAs: any;

@Injectable()
export class GetDataService {
  public serverIp = "70.104.134.90";
  public serverPort = 8000;
  //public serverIp = 'localhost';
  public url_HTTPLoginAppusers =
    "http://" + this.serverIp + ":" + this.serverPort + "/appuser/signin";
  public url_HTTPgetBrowseCases =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/browsecases";
  public url_HTTPgetUndertenants =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/undertenants";
  public url_HTTPgetOrderToShowcase =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/ordertoshowcase";
  public url_HTTPgetNoticeofEviction =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/noticeofeviction";
  public url_HTTPgetEvictiondetail =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/evictiondetail";
  public url_HTTPgetCharges =
    "http://" + this.serverIp + ":" + this.serverPort + "/docketinfo/charges";
  public url_HTTPgetApprovalStatus =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/approvalstatus";

  public url_HTTPgetCustomeSearch =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/customsearch";
  public url_HTTPgetWarrantCourtStatus =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/warrantcourtstatus";

  public url_HTTPgetAPS = "http://" + this.serverIp + ":8000/docketinfo/aps";

  public url_HTTPgetWarrentstatushistory =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/docketinfo/warrentstatushistory";

  public url_HTTPgetNewCasesLog =
    "http://" + this.serverIp + ":" + this.serverPort + "/reports/newcaseslog";
  public url_HTTPspGetAttorneyAgents =
    "http://" +
    this.serverIp +
    ":" +
    this.serverPort +
    "/reports/getAttorneyAgents";

  public url_HTTPspGetUsuarios =
    "http://" + this.serverIp + ":" + this.serverPort + "/appuser/getusuarios";

  public url_HTTPLink = "http://" + this.serverIp + ":8000/api/";
  public url_HTTPCompany = "http://" + this.serverIp + ":8000/api/company";
  public url_HTTPMarshal = "http://" + this.serverIp + ":8000/api/marshal";
  public url_HTTPLawyer = "http://" + this.serverIp + ":8000/api/lawyer";
  public url_HTTPBrowseCases =
    "http://" + this.serverIp + ":8000/api/browsecases";
  public url_HTTPUnderTenants =
    "http://" + this.serverIp + ":8000/api/undertenant";
  public url_HTTPUnderNoticeOfEviction =
    "http://" + this.serverIp + ":8000/api/noticeofeviction";
  public url_HTTPAppusers = "http://" + this.serverIp + ":8000/api/appusers";
  public url_HTTPLoginLawyer =
    "http://" + this.serverIp + ":8000/api/loginlawyer";
  public url_HTTPLoginMarshal =
    "http://" + this.serverIp + ":8000/api/loginmarshal";
  public url_HTTPorderToShowcase =
    "http://" + this.serverIp + ":8000/api/orderToShowcase";
  public url_HTTPCustomSearch =
    "http://" + this.serverIp + ":8000/api/customsearch";
  public url_HTTPMashalLawyerLink =
    "http://" + this.serverIp + ":8000/api/marshallawyerlink";
  public url_HTTPGetLink = "http://" + this.serverIp + ":8000/api/getlink";

  public headers = new Headers();
  public results = [];
  public cIsActive = new CIsActive();

  constructor(private http: HttpClient) {}
  // ** observables variables //
  userLoggedIn: BehaviorSubject<CAppusers[]> = new BehaviorSubject<CAppusers[]>(
    []
  );
  cast = this.userLoggedIn.asObservable();
  /// ******************** ///
  OnInit() {}
  // ** observables functions //
  updateUserLoggedIn(value) {
    this.userLoggedIn.next(value);
  }
  /// ******************** ///

  // *** Manage company *******
  doPostCompany(value) {
    return this.http
      .post(this.url_HTTPLink + "company", value, httpOptions)
      .catch(this.handleError);
  }

  doGetCompany(searchKey) {
    return this.http
      .get(this.url_HTTPLink + "company", { params: searchKey })
      .catch(this.handleError);
  }
  doChangeCountryIsActive(value) {
    return this.http
      .put(this.url_HTTPLink + "company", value, httpOptions)
      .catch(this.handleError);
  }
  // End company

  // *** Manage Marshal ***

  // **** End Marshal ****

  // *** Manage Marshal ***

  doCustomSearch(searchKey) {
    console.log("custome search ifno");
    console.log(searchKey);
    console.log(this.url_HTTPgetCustomeSearch);
    console.log("====================");
    return this.http
      .get(this.url_HTTPgetCustomeSearch, {
        params: searchKey,
      })
      .catch(this.handleError);
  }

  // New version
  doLoginAppusers(sender, searchKey) {
    // console.log("Search and Link");
    // console.log(this.url_HTTPgetBrowseCases);
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPLoginAppusers, { params: searchKey })
      .catch(this.handleError);
  }

  doGetBrowseCases(sender, searchKey) {
    // console.log('Search and Link')
    // console.log(this.url_HTTPgetBrowseCases);
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPgetBrowseCases, { params: searchKey })
      .catch(this.handleError);
  }
  doGetUnderTenants(sender, searchKey) {
    // console.log('Search and Link')
    // console.log(this.url_HTTPgetBrowseCases);
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPgetUndertenants, { params: searchKey })
      .catch(this.handleError);
  }

  doOrderToShowcase(sender, searchKey) {
    return this.http
      .get(this.url_HTTPgetOrderToShowcase, { params: searchKey })
      .catch(this.handleError);
  }

  doGetNoticeOfEviction(searchKey) {
    return this.http
      .get(this.url_HTTPgetNoticeofEviction, { params: searchKey })
      .catch(this.handleError);
  }
  doGetEvictionDetail(cDataRequest) {
    const keySearch = cDataRequest.keySearch;
    return this.http
      .get(this.url_HTTPgetEvictiondetail, { params: keySearch })
      .catch(this.handleError);
  }

  doGetCharges(cDataRequest) {
    // console.log('from charges services')
    // console.log(cDataRequest.keySearch )
    return this.http
      .get(this.url_HTTPgetCharges, { params: cDataRequest.keySearch })
      .catch(this.handleError);
  }

  doGetApprovalStatus(cDataRequest) {
    const keySearch = cDataRequest.keySearch;
    return this.http
      .get(this.url_HTTPgetApprovalStatus, { params: keySearch })
      .catch(this.handleError);
  }

  doGetAps(cDataRequest) {
    // console.log("From Services APS");
    // console.log(cDataRequest);
    return this.http
      .get(this.url_HTTPgetAPS, { params: cDataRequest })
      .catch(this.handleError);
  }

  doGetWarrentstatushistory(cDataRequest) {
    // console.log(cDataRequest);
    // console.log(cDataRequest.searchKey);
    return this.http
      .get(this.url_HTTPgetWarrentstatushistory, { params: cDataRequest })
      .catch(this.handleError);
  }

  doGetNewCasesLog(cDataRequest) {
    var mediaType = "application/pdf";
    return this.http
      .post(
        this.url_HTTPgetNewCasesLog,
        { location: "report.pdf" },
        { responseType: "blob" }
      )
      .subscribe(
        (response) => {
          var blob = new Blob([response], { type: mediaType });
          saveAs(blob, "report.pdf");
        },
        (e) => {
          throwError(e);
        }
      );
    //---------------------------
    // let headers = new HttpHeaders();
    // headers = headers.set("Accept", "application/pdf");
    // return this.http.get(this.url_HTTPgetNewCasesLog, {
    //   headers: headers,
    //   responseType: "blob",
    //   params: cDataRequest,
    // });
    // ---------------------------
    // console.log('New Cases Log Request');
    // console.log(this.url_HTTPgetNewCasesLog)
    // console.log(cDataRequest);

    // return this.http
    //   .get(this.url_HTTPgetNewCasesLog, { params: cDataRequest })
    //   .catch(this.handleError);
  }

  doWarrantCourtStatus(sender, searchKey) {
    // console.log('Search and Link')
    // console.log("link for search: ", this.url_HTTPgetWarrantCourtStatus);
    console.log("keysearch data service:", {
      keySearch: searchKey.keySearch.docketNumber,
    });
    return this.http
      .get(this.url_HTTPgetWarrantCourtStatus, {
        params: { keySearch: searchKey.keySearch.docketNumber },
      })
      .catch(this.handleError);
  }

  doGetAttorneyAgents(attnyRowId: any) {
    // console.log('New Cases Log Request');
    // console.log(this.url_HTTPgetNewCasesLog)
    // console.log(cDataRequest);
    console.log("attnyRowId");
    console.log(attnyRowId);
    return this.http
      .get(this.url_HTTPspGetAttorneyAgents, { params: attnyRowId })
      .catch(this.handleError);
  }
  doGetUsuarios() {
    // console.log('New Cases Log Request');
    // console.log(this.url_HTTPgetNewCasesLog)
    // console.log(cDataRequest);
    return this.http.get(this.url_HTTPspGetUsuarios).catch(this.handleError);
  }

  // End new version

  doAddMarshal(sender, value) {
    // console.log(value);
    return this.http
      .post(this.url_HTTPMarshal, value, httpOptions)
      .catch(this.handleError);
  }

  doGetMarshal(searchKey) {
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPMarshal, { params: searchKey })
      .catch(this.handleError);
  }
  doChangeIsActiveMarshal(sender, value) {
    // console.log(value);
    return this.http
      .put(this.url_HTTPMarshal, value, httpOptions)
      .catch(this.handleError);
  }
  doUpdateMarshal(sender, value) {
    // console.log(value);
    return this.http
      .put(this.url_HTTPMarshal, value, httpOptions)
      .catch(this.handleError);
  }
  // **** End Company ****

  // *** Manage Lawyer ***

  doAddLawyer(sender, value) {
    // console.log(value);
    return this.http
      .post(this.url_HTTPLawyer, value, httpOptions)
      .catch(this.handleError);
  }

  doGetLawyer(sender, searchKey) {
    // console.log('here its searchKey for lawyer');
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPLawyer, { params: searchKey })
      .catch(this.handleError);
  }
  doChangeIsActiveLawyer(sender, value) {
    // console.log(value);
    return this.http
      .put(this.url_HTTPLawyer, value, httpOptions)
      .catch(this.handleError);
  }
  doUpdateLawyer(sender, value) {
    // console.log(value);
    return this.http
      .put(this.url_HTTPLawyer, value, httpOptions)
      .catch(this.handleError);
  }
  // **** End Company ****
  private handleError(err: HttpErrorResponse) {
    console.log("here the error from http server");
    console.log(err);
    return Observable.throw(
      "ERROR: " + err.status + " " + err.statusText + " " + err.error["data"]
    );
  }

  doAddAppusers(sender, value) {
    // console.log(value);
    this.http.post(this.url_HTTPAppusers, value, httpOptions).subscribe(
      (res) => {
        // console.log(res);
      },
      (error) => {
        // console.log('Error' + error);
      }
    );
  }

  doAddMarshalLawyerLink(sender, value) {
    // console.log(sender);
    // console.log(value);
    return this.http
      .post(this.url_HTTPMashalLawyerLink, value, httpOptions)
      .catch(this.handleError);
  }
  doGetFindLink(searchKey) {
    // console.log(searchKey);
    return this.http
      .get(this.url_HTTPGetLink, { params: searchKey })
      .catch(this.handleError);
  }
}
